export interface Values {
  email: string
  token: string
  newPassword: string
  newPasswordConfirmation: string
}

const initialValues: Values = {
  email: '',
  token: '',
  newPassword: '',
  newPasswordConfirmation: '',
}

export default initialValues
